<gbc-tile [title]="'mixit-weather-curve-tile.weather-compensation' | translate" class="tile">

  @if (editingVisible$ | async) {
    <button gbc-icon-button gbc-tile-right
      [title]="'weather-curve-tile.adjust-curve'| translate"
      [disabled]="editing"
      (click)="edit()"
      angulartics2On="click"
      angularticsAction="adjustMixitWeatherCurve"
      angularticsCategory="mixitWeatherCurve"
      data-test-id="mixitWeatherCurveAdjust">
      <img [alt]="'weather-curve-tile.adjust-curve' | translate" src="./assets/svgs/adjust-outline-black.svg">
    </button>
  }

  <div class="content">

    @if (!editing) {
      <app-weather-curve-chart
        class="chart"
        [outdoorTemp$]="outdoorTemp$"
        [data$]="data$">
      </app-weather-curve-chart>
    }

    @if (editing) {
      <app-weather-curve-chart
        class="chart"
        [outdoorTemp$]="outdoorTemp$"
        [data$]="curveBeingEdited$">
      </app-weather-curve-chart>
    }

    @if (editing) {
      <div class="controls">
        @if (isSimpleEditingMode) {
          <div class="simple-editor-container ">
            <div class="controls-header">
              <a href="javascript:void(0)" (click)="customize()">{{'mixit-weather-curve-tile.advanced-editor' | translate}}</a>
            </div>
            <div class="description-container">
              <img class="description-image" src="./assets/svgs/adjust-offset.svg">
              <div class="description">
                {{'mixit-weather-curve-tile.offset-curve' | translate}}
              </div>
            </div>
            <div class="button-container">
              <button gbc-button ghost
                [disabled]="(canMoveDown$ | async) === false"
                (click)="minusOneDegree()"
                angulartics2On="click"
                angularticsAction="minusOneDegreeClicked"
                angularticsCategory="mixitWeatherCurve">
                - 1 °C
              </button>
              <button gbc-button ghost
                [disabled]="(canMoveUp$ | async) === false"
                (click)="plusOneDegree()"
                angulartics2On="click"
                angularticsAction="plusOneDegreeClicked"
                angularticsCategory="mixitWeatherCurve">
                + 1 °C
              </button>
            </div>
            <div class="description-container">
              <img class="description-image" src="./assets/svgs/adjust-slope.svg">
              <div class="description">
                {{'mixit-weather-curve-tile.adjust-curve-slope' | translate}}
              </div>
            </div>
            <div class="button-container">
              <button gbc-button ghost
                [disabled]="(canSlopeDown$ | async) === false"
                class="icon-button"
                id="rollLeft"
                (click)="adjustCurveLeft()"
                angulartics2On="click"
                angularticsAction="adjustCurveLeftClicked"
                angularticsCategory="mixitWeatherCurve">
                <img src="./assets/svgs/adjust-roll-left.svg" alt="">
              </button>
              <button gbc-button ghost
                [disabled]="(canSlopeUp$ | async) === false"
                class="icon-button"
                id="rollRight"
                (click)="adjustCurveRight()"
                angulartics2On="click"
                angularticsAction="adjustCurveRightClicked"
                angularticsCategory="mixitWeatherCurve">
                <img src="./assets/svgs/adjust-roll-right.svg" alt="">
              </button>
            </div>
          </div>
        }
        @if (!isSimpleEditingMode) {
          <div class="controls-header">
            <a href="javascript:void(0)" (click)="customize()">{{'mixit-weather-curve-tile.simple-editor' | translate}}</a>
          </div>
          <form [formGroup]="form">
            <div class="input-container" [ngClass]="{ 'dynamic': (isDynamicCurveData$ | async) === true }">
              @if ((isDynamicCurveData$ | async) === false) {
                <div class="degree">-20°C</div>
              }
              @if ((isDynamicCurveData$ | async) === true) {
                <gbc-input-field formControlName="dataX0" class="dynamic" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="X_MIN_MAX"></gbc-input-field>
              }
              <gbc-input-field formControlName="minus20" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="MINMAX"></gbc-input-field>
            </div>
            <div class="input-container" [ngClass]="{ 'dynamic': (isDynamicCurveData$ | async) === true }">
              @if ((isDynamicCurveData$ | async) === false) {
                <div class="degree">-10°C</div>
              }
              @if ((isDynamicCurveData$ | async) === true) {
                <gbc-input-field formControlName="dataX1" class="dynamic" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="X_MIN_MAX"></gbc-input-field>
              }
              <gbc-input-field formControlName="minus10" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="MINMAX"></gbc-input-field>
            </div>
            <div class="input-container" [ngClass]="{ 'dynamic': (isDynamicCurveData$ | async) === true }">
              @if ((isDynamicCurveData$ | async) === false) {
                <div class="degree">0°C</div>
              }
              @if ((isDynamicCurveData$ | async) === true) {
                <gbc-input-field formControlName="dataX2" class="dynamic" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="X_MIN_MAX"></gbc-input-field>
              }
              <gbc-input-field formControlName="zero" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="MINMAX"></gbc-input-field>
            </div>
            <div class="input-container" [ngClass]="{ 'dynamic': (isDynamicCurveData$ | async) === true }">
              @if ((isDynamicCurveData$ | async) === false) {
                <div class="degree">10°C</div>
              }
              @if ((isDynamicCurveData$ | async) === true) {
                <gbc-input-field formControlName="dataX3" class="dynamic" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="X_MIN_MAX"></gbc-input-field>
              }
              <gbc-input-field formControlName="plus10" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="MINMAX"></gbc-input-field>
            </div>
            <div class="input-container" [ngClass]="{ 'dynamic': (isDynamicCurveData$ | async) === true }">
              @if ((isDynamicCurveData$ | async) === false) {
                <div class="degree">20°C</div>
              }
              @if ((isDynamicCurveData$ | async) === true) {
                <gbc-input-field formControlName="dataX4" class="dynamic" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="X_MIN_MAX"></gbc-input-field>
              }
              <gbc-input-field formControlName="plus20" unit="°C" inputType="number" errorDescriptionTranslationString="app-enter-value-between" [errorDescriptionData]="MINMAX"></gbc-input-field>
            </div>
          </form>
        }
        <div class="slope">
          @if (slopeTooSteep$ | async) {
            <div>{{'mixit-weather-curve-tile.slope-too-steep' | translate}}</div>
          }
          @if (slopeTooFlat$ | async) {
            <div>{{'mixit-weather-curve-tile.slope-too-flat' | translate}}</div>
          }
          @if (invalidRangeOrder$ | async) {
            <div>{{'mixit-weather-curve-tile.outdoor-range-invalid' | translate}}</div>
          }
        </div>
        @if (editing) {
          <div class="save-cancel-buttons">
            <div>
              <button gbc-button ghost
                (click)="cancel()"
                class="cancel-button"
                angulartics2On="click"
                angularticsAction="cancelClicked"
                angularticsCategory="mixitWeatherCurve">
                {{'app-cancel' | translate}}
              </button>
              <button gbc-button
                (click)="save()"
                [disabled]="(valid$ | async) === false"
                class="save-button"
                angulartics2On="click"
                angularticsAction="saveClicked"
                angularticsCategory="mixitWeatherCurve">
                {{'app-save' | translate}}
              </button>
            </div>
            <div class="mt-4" style="text-align: center">
              <a href="javascript:void(0)" (click)="resetToDefault()">{{'mixit-weather-curve-tile.reset-to-default' | translate}}</a>
            </div>
          </div>
        }
      </div>
    }
  </div>
</gbc-tile>



